import React from 'react';
import moment from 'moment';
import PropTypes from 'prop-types';

const dateTypes = [
  PropTypes.string,
  PropTypes.number,
  PropTypes.array,
  PropTypes.object
];

const Moment = ({ date, children, tz, format, ...props }) => {
  const dateTime = moment(date || children).tz(tz);
  const dateStr = dateTime.format(format);
  return (
    <time
      dateTime={dateTime}
      aria-label={dateStr}
      {...props}
    >
      {dateStr}
    </time>
  );
};

Moment.propTypes = {
  date: PropTypes.oneOfType(dateTypes),
  children: PropTypes.oneOfType(dateTypes),
  tz: PropTypes.string.isRequired,
  format: PropTypes.string.isRequired,
};

Moment.defaultProps = {
  date: null,
  children: null
};

export default Moment;
